/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_DoneInputs */

const en_recovery_codes_done = /** @type {(inputs: Recovery_Codes_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I've stored them safely`)
};

const de_recovery_codes_done = /** @type {(inputs: Recovery_Codes_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe sie sicher gespeichert`)
};

/**
* | output |
* | --- |
* | "I've stored them safely" |
*
* @param {Recovery_Codes_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_done = /** @type {((inputs?: Recovery_Codes_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_done(inputs)
	return en_recovery_codes_done(inputs)
});